(function () {

  // Version marker. Type `window.salineAjaxCartVersion` in the browser console:
  // if it prints undefined, this file is not the one your browser loaded.
  window.salineAjaxCartVersion = '2026-09-02c';

  // Bind once per page. This script is included by more than one section (the
  // home page featured products grid and the category / collection grid), so
  // without this guard a page holding both would attach two click handlers and
  // a single click would add the product to the cart twice.
  if (window.salineAjaxCartInit) return;
  window.salineAjaxCartInit = true;

  // `.ajax-cart-btn` is the home page product card button; `.cat-card-add-btn`
  // is the category / collection grid button. Matching each button's own
  // existing class rather than adding a shared one keeps their styling intact.
  var BUTTON_SELECTOR = '.ajax-cart-btn[data-variant-id], .cat-card-add-btn[data-variant-id]';

  // Delegated from document rather than bound to each button on
  // DOMContentLoaded. Shopify's theme editor re-renders a section's markup in
  // place, which silently destroys listeners bound to the original nodes.
  //
  // NOTE the `true` at the end: this listens in the CAPTURE phase, and it has
  // to. The home page button carries an inline onclick="event.stopPropagation()"
  // to stop the surrounding product card navigating to the product page. In the
  // bubble phase that inline handler fires first and kills the event at the
  // button, so a document-level listener would never see a home page click.
  // Capture runs top-down, so we get the event before the button does.
  document.addEventListener('click', async function (e) {

    var target = e.target;

    // e.target can be an inner <span> or the button's SVG icon. closest() only
    // exists on Elements, so walk up from a non-element target defensively.
    if (!target || typeof target.closest !== 'function') {
      target = target && target.parentElement;
    }

    if (!target || typeof target.closest !== 'function') return;

    var button = target.closest(BUTTON_SELECTOR);

    if (!button || button.disabled) return;

    // The category grid button is a real submit button inside a product form,
    // kept as a no-JavaScript fallback. Cancel the submit now that we handle
    // the add over AJAX. stopPropagation also prevents the home page product
    // card's onclick from navigating away mid-add.
    e.preventDefault();
    e.stopPropagation();

    if (button.dataset.ajaxCartBusy === 'true') return;
    button.dataset.ajaxCartBusy = 'true';

    var variantId = button.dataset.variantId;

    if (!variantId) {
      button.dataset.ajaxCartBusy = 'false';
      return;
    }

    var originalText = button.innerHTML;

    button.classList.add('loading');
    button.innerHTML = 'Adding...';

    try {

      var response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          id: variantId,
          quantity: 1
        })
      });

      if (!response.ok) {
        throw new Error('Cart add failed with status ' + response.status);
      }

      button.classList.remove('loading');
      button.classList.add('added');
      button.innerHTML = '✓ Added';

      await refreshCartDrawer();

      setTimeout(function () {

        button.classList.remove('added');
        button.innerHTML = originalText;
        button.dataset.ajaxCartBusy = 'false';

      }, 1800);

    } catch (error) {

      console.error('[saline cart]', error);

      button.classList.remove('loading');
      button.innerHTML = 'Try Again';

      setTimeout(function () {

        button.innerHTML = originalText;
        button.dataset.ajaxCartBusy = 'false';

      }, 1800);

    }

  }, true);

})();


async function refreshCartDrawer() {

  const currentDrawer = document.querySelector('cart-drawer');

  // No cart drawer on this template. Send the shopper to the cart page rather
  // than leaving the add with no visible result.
  if (!currentDrawer) {
    console.warn('[saline cart] no <cart-drawer> on this page, going to /cart');
    window.location = '/cart';
    return;
  }

  const response = await fetch('/?section_id=cart-drawer');

  const html = await response.text();

  const parser = new DOMParser();

  const documentHTML = parser.parseFromString(html, 'text/html');

  const newDrawer = documentHTML.querySelector('cart-drawer');

  if (newDrawer) {

    // Preserve the drawer's open/animation state before syncing classes.
    const wasActive = currentDrawer.classList.contains('active');
    const wasAnimating = currentDrawer.classList.contains('animate');

    currentDrawer.innerHTML = newDrawer.innerHTML;

    // Copy state classes from the freshly rendered section onto the live host
    // element. innerHTML alone never updates the host's own class attribute, so
    // on the first add the host kept `is-empty` and the CSS rules
    // `cart-drawer.is-empty .drawer__header` / `.drawer__inner` hid the header
    // and collapsed the layout, leaving the new line item invisible.
    currentDrawer.className = newDrawer.className;

    if (wasAnimating) currentDrawer.classList.add('animate');
    if (wasActive) currentDrawer.classList.add('active');

    // The overlay node that cart-drawer.js bound its close handler to in the
    // constructor was just destroyed by the innerHTML swap. Rebind it on the
    // fresh node so clicking outside the drawer still closes it.
    const overlay = currentDrawer.querySelector('#CartDrawer-Overlay');

    if (overlay && typeof currentDrawer.close === 'function') {
      overlay.addEventListener('click', currentDrawer.close.bind(currentDrawer));
    }

  }

  if (typeof currentDrawer.open === 'function') {

    currentDrawer.open();

  } else {

    console.warn('[saline cart] cart-drawer element has no open() method');

  }

  updateCartBubble();

}


async function updateCartBubble() {

  // Re-render the header cart link from the server section. Its markup is the
  // cart SVG icon + hidden label + count bubble, so writing bare count spans
  // into it (as this function previously did) removed the icon from the header.
  // Only the contents are replaced, never the <a> itself, so the click handler
  // cart-drawer.js binds to it stays intact.
  const response = await fetch('/?section_id=cart-icon-bubble');

  const html = await response.text();

  const documentHTML = new DOMParser().parseFromString(html, 'text/html');

  const newBubble = documentHTML.querySelector('.shopify-section') || documentHTML.body;

  const cartIcon = document.querySelector('#cart-icon-bubble');

  if (newBubble && cartIcon) {

    cartIcon.innerHTML = newBubble.innerHTML;

  }

  // Any count bubbles rendered outside the header cart link (e.g. a sticky
  // mobile bar) are still updated by item count, exactly as before.
  const otherBubbles = Array.from(document.querySelectorAll('.cart-count-bubble')).filter(
    (bubble) => !cartIcon || !cartIcon.contains(bubble)
  );

  if (otherBubbles.length === 0) return;

  const cartResponse = await fetch('/cart.js');

  const cart = await cartResponse.json();

  otherBubbles.forEach((bubble) => {

    bubble.innerHTML = `
      <span aria-hidden="true">${cart.item_count}</span>
      <span class="visually-hidden">${cart.item_count} items</span>
    `;

  });

}
